/**
 * Transformación libre (CSS vars) para hotspots tipo persona/objeto en escena.
 * Misma forma que la flecha/logo (rotate, scale, skew, perspectiva, offset).
 */

export const DEFAULT_PERSONA_TRANSFORM = {
  rotateDelta: 0,
  scaleX: 1,
  scaleY: 1,
  skewX: 0,
  skewY: 0,
  perspectiveX: 0,
  perspectiveY: 0,
  offsetX: 0,
  offsetY: 0
};

function numOr(raw, fallback) {
  const n = Number(raw);
  return Number.isFinite(n) ? n : fallback;
}

/**
 * Fusiona JSON guardado en BD con valores por defecto para persona.
 */
export function normalizePersonaTransformFromDb(raw) {
  const t = raw && typeof raw === 'object' && !Array.isArray(raw) ? raw : {};
  const d = DEFAULT_PERSONA_TRANSFORM;
  return {
    rotateDelta: numOr(t.rotateDelta, d.rotateDelta),
    scaleX: numOr(t.scaleX, d.scaleX) || 1,
    scaleY: t.scaleY != null && Number.isFinite(Number(t.scaleY)) ? Number(t.scaleY) : d.scaleY,
    skewX: numOr(t.skewX, d.skewX),
    skewY: numOr(t.skewY, d.skewY),
    perspectiveX: numOr(t.perspectiveX, d.perspectiveX),
    perspectiveY: numOr(t.perspectiveY, d.perspectiveY),
    offsetX: numOr(t.offsetX, d.offsetX),
    offsetY: numOr(t.offsetY, d.offsetY)
  };
}
